import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles";
import { useTheme as useAppTheme } from "../contexts/ThemeContext";

export default function ThemeConfig({ children }) {
  const { theme } = useAppTheme();

  const themeOptions = {
    palette: {
      mode: theme === "dark" ? "dark" : "light",
      primary: {
        main: "#137fec",
      },
      secondary: {
        main: "#137fec",
      },
      background: {
        default: theme === "dark" ? "#0a0e13" : "#ebebeb",
        paper: theme === "dark" ? "#1a2332" : "#ffffff",
      },
      text: {
        primary: theme === "dark" ? "#d6e4f0" : "#0f172a",
        secondary: theme === "dark" ? "#92adc9" : "#64748b",
      },
    },
    typography: {
      fontFamily: '"Parkinsans", sans-serif',
    },
    components: {
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: "#137fec", // unchecked color
            "&.Mui-checked": {
              color: "#137fec", // checked color
            },
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: "#137fec", // unchecked color
            "&.Mui-checked": {
              color: "#137fec", // checked color
            },
          },
        },
      },
    },
  };

  const muiTheme = createTheme(themeOptions);

  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
}
